// extracted by mini-css-extract-plugin
export var item = "RuledList-module--item--hmFdZ";
export var list = "RuledList-module--list--h1XIA";
export var ruleBottom = "RuledList-module--ruleBottom--Bp14K";
export var ruleTop = "RuledList-module--ruleTop--TRXF4";